// import { call, put, take, takeLatest } from "redux-saga/effects";
// import authTypes from "../types/auth";
// import auth from "../actions/auth";
// import axios from "../../services/axios";
// import role from "../actions/role"

// function* LoginUser({ payload }) {

//   try {
//     if ((payload.uid || payload.inviteId) && payload.password) {
//       const res = yield call(axios.request, {
//         method: "POST",
//         url: (payload.inviteId && payload?.cl==0)? "/user/candidateLogin":"/user/login",
//         data: payload

//       });
//       localStorage.setItem("token1", `Bearer ${(res.token)}`)
//       localStorage.setItem('userid', res.userId)
//       localStorage.setItem("user_details", JSON.stringify(res))
//       yield put(auth.LoginUserSuccess(res));
//     }
//   }
//   catch (err) {
//     yield put(auth.apiError(err));
//   }
// }

function* authSaga() {
  // yield takeLatest(authTypes.LOGIN_USER, LoginUser)
}

export { authSaga };
